module.exports = __webpack_public_path__ + "img/icon_sm_yszktj.6216cf39.png";